module.exports = "/next-static/_next/static/images/block_image_guest_interviews-5ce1e976425eb8a0bf123394f31574c4.webp";